// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://wbuwvhmfdrjsbxuerkpx.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndidXd2aG1mZHJqc2J4dWVya3B4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwODQ3MzksImV4cCI6MjA4ODY2MDczOX0.Ue8CR6oeud9l7A0xet61Xd95Y0-hD6s3E0sEiaH2_Cc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});